import ActionMenu from '../../../../components/action-buttons/ActionButtons';
import { BUTTON_CONSTANTS, LABEL_CONSTANTS } from '../../../../constants/common';

interface PaymentHistoryActionControlProps {
  isEnabled: boolean;
  onMarkAsPaid: () => void;
  onViewDetails: () => void;
}

const PaymentHistoryActionControl = ({
  isEnabled,
  onMarkAsPaid,
  onViewDetails,
}: PaymentHistoryActionControlProps): JSX.Element => {
  const actionButtons = [
    {
      name: BUTTON_CONSTANTS.VIEW_DETAILS,
      action: onViewDetails,
    } as any,
  ];

  if (isEnabled) {
    actionButtons.push({ name: LABEL_CONSTANTS.MARK_AS_PAID, action: onMarkAsPaid });
  }

  return (
    <div className={'payment-history__action-menu-enabled'}>
      <ActionMenu actionButtons={actionButtons} />
    </div>
  );
};

export default PaymentHistoryActionControl;
